import { useEffect, useRef } from 'react';
import type { StationSnapshot } from './types';

const AHEAD = 3;

function post(ids: string[]): void {
  if (!ids.length || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.active?.postMessage({ type: 'prefetch', ids }))
    .catch(() => {});
}

/** Keep the current song + the next few fully downloaded on this device (via the service
 *  worker), so a network dropout mid-song costs nothing. */
export function usePrefetch(snap: StationSnapshot): void {
  const ids: string[] = [];
  const cur = snap.nowPlaying?.track.videoId;
  if (cur) ids.push(cur);
  for (const t of snap.queue) {
    if (t.videoId && !ids.includes(t.videoId)) ids.push(t.videoId);
    if (ids.length >= AHEAD + 1) break;
  }
  const key = ids.join(',');
  const keyRef = useRef(key);
  keyRef.current = key;

  useEffect(() => {
    if (key) post(key.split(','));
  }, [key]);

  // 首次询问时服务器可能还没缓存完这首 — 周期性再问, SW 只补缺的
  useEffect(() => {
    const t = window.setInterval(() => {
      if (keyRef.current) post(keyRef.current.split(','));
    }, 30_000);
    return () => window.clearInterval(t);
  }, []);
}
